import React from 'react';
import MenuItem from 'material-ui/MenuItem';
import Dialog from 'material-ui/Dialog';
import Divider from 'material-ui/Divider';
import FlatButton from 'material-ui/FlatButton';
import {FormattedMessage} from 'react-intl';
import Formsy from 'formsy-react';
import {FormsyDate, FormsySelect, FormsyText, FormsyTime} from 'formsy-material-ui/lib';
import AutoComplete from 'material-ui/AutoComplete';
import './addEventDialog.css';
import {formatDate} from '../utils/dateTimeUtils'
import PoweredByGoogleIMG from "../assets/powered_by_google.png";

var style = {
    'paddingTop': '20%',
    'color': '#ffffff',
    'fontSize': 34,
};

class AddEventComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canSubmit: false,
            location: "",
        }
    }

    componentWillReceiveProps = (newProps) => {
        if (this.props.open !== newProps.open) {
            this.setState({
                location: ""
            })
        }
    };

    handleUpdateInput = (string) => {
        if (string.length >= 3) {
            this.props.onUpdate(string);
        } else {
            this.props.onUpdate("");
        }
    };

    handleLocationChange = (value) => {
        this.setState({
            location: value,
        })
    };

    submitForm = (options) => {
        let year = options.date.getFullYear();
        let month = options.date.getMonth();
        let day = options.date.getDate();
        let hours = options.time.getHours();
        let mins = options.time.getMinutes();
        let date = new Date(year, month, day, hours, mins);
        let location = this.state.location;
        if (location.length <= 0) {
            location = "no location set";
        }
        if (!options.template.id) {
            options.template = {id: options.template.objectId, name: options.template.name}
        }
        this.props.onCreateEvent(date, options.title, options.type, location, options.template);
    };

    enableButton = () => {
        this.setState({
            canSubmit: true
        });
    };

    disableButton = () => {
        this.setState({
            canSubmit: false
        });
    };

    onCancel = () => {
        this.setState({
            location: ""
        });
        this.props.handleClose();
    };

    render() {
        const actions = [
            <FlatButton
                label={
                    <FormattedMessage
                        id="general.cancelText"
                        defaultMessage="Cancel"
                    />
                }
                className="cancelBtn"
                primary={true}
                onTouchTap={this.onCancel}
            />,

            <FlatButton
                label={
                    <FormattedMessage
                        id="addEvent.createEventInDialogButton"
                    />
                }
                primary={true}
                type="submit"
                disabled={!this.state.canSubmit}
                onTouchTap={() => {
                    this.formsyForm.submit();
                }}
            />,
        ];
        return (
            <div>
                <Dialog
                    open={this.props.open}
                    modal={true}
                    actions={actions}
                    title={
                        <div className="dialogTitleClass">
                            <FormattedMessage
                                id="addEvent.createEventInDialogTitle"
                            />
                            <div style={{fontSize: '14px', marginLeft: '2px'}}>
                                <FormattedMessage id={"addEvent.createEventWarningMessage"}/>
                                <a style={{marginLeft: '5px', color: 'rgb(165 228 253)'}}
                                   target="_blank"
                                   href={"https://calendly.com/michaelmahler/vibo_2-0_beta"}>Click here to schedule a handover
                                    meeting</a>
                            </div>
                        </div>
                    }
                    titleStyle={style}
                    //paperClassName = "bodyClass"
                >
                    <Formsy.Form
                        ref={(form) => {
                            this.formsyForm = form;
                        }}
                        onSubmit={this.submitForm.bind(this)}
                        onValid={this.enableButton}
                        onInvalid={this.disableButton}
                    >

                        <FormsySelect
                            name="type"
                            required
                            style={{'verticalAlign': 'bottom', 'display': 'inline-block', 'width': '45%'}}
                            floatingLabelText={
                                <FormattedMessage
                                    id="addEvent.eventType"
                                />
                            }
                            onChange={this.handleSelectChange}
                        >
                            {this.props.eventTypes.map((eventType, index) =>
                                <MenuItem key={index} value={eventType} primaryText={eventType}/>
                            )}
                        </FormsySelect>

                        <FormsySelect
                            name="template"
                            required
                            style={{
                                'verticalAlign': 'bottom',
                                'display': 'inline-block',
                                'width': '45%',
                                'marginLeft': '5%'
                            }}
                            floatingLabelText={
                                <FormattedMessage id="addEvent.eventTemplate"/>
                            }>
                            <label className="selectMenuSubTitle"><FormattedMessage
                                id="addEvent.yourTemplatesSubtitle"/></label>
                            {this.props.userTemplates.map((template, index) =>
                                <MenuItem key={index} value={template} primaryText={template.name}/>
                            )}
                            <Divider/>
                            <label className="selectMenuSubTitle"><FormattedMessage
                                id="addEvent.viboTemplatesSubtitle"/></label>
                            {this.props.defaultTemplates.map((template, index) =>
                                <MenuItem key={this.props.userTemplates.length + index} value={template}
                                          primaryText={template.name}/>
                            )}
                        </FormsySelect>
                        <FormsyText
                            floatingLabelText={
                                <FormattedMessage
                                    id="addEvent.eventTitle"/>
                            }
                            required
                            style={{'verticalAlign': 'bottom', 'width': '45%'}}
                            name="title"
                            onChange={this.handleTitleChange}
                            value={this.state.eventTitle}
                            fullWidth={true}
                        />
                        <AutoComplete
                            searchText={this.state.location}
                            dataSource={this.props.places}
                            filter={(searchText, key) => true}
                            onNewRequest={this.handleLocationChange}
                            onUpdateInput={this.handleUpdateInput}
                            menuStyle={{
                                paddingTop: '10px',
                                backgroundImage: `url(${PoweredByGoogleIMG})`,
                                backgroundPosition: 'right top',
                                backgroundRepeat: 'no-repeat'
                            }}
                            fullWidth={true}
                            floatingLabelText={
                                <FormattedMessage
                                    id="addEvent.eventLocation"/>
                            }
                            style={{
                                'verticalAlign': 'bottom',
                                'display': 'inline-block',
                                'width': '45%',
                                'marginLeft': '5%'
                            }}
                        />
                        <FormsyDate
                            name="date"
                            floatingLabelText={
                                <FormattedMessage
                                    id="addEvent.datePicker"/>
                            }
                            required
                            style={{'verticalAlign': 'bottom', 'display': 'inline-block', 'width': '45%'}}
                            autoOk={true}
                            fullWidth={true}
                            container="inline" mode="landscape"
                            formatDate={formatDate}
                        />
                        <FormsyTime
                            name="time"
                            floatingLabelText={
                                <FormattedMessage
                                    id="addEvent.eventTime"/>
                            }
                            required
                            fullWidth={true}
                            style={{
                                'verticalAlign': 'bottom',
                                'display': 'inline-block',
                                'width': '45%',
                                'marginLeft': '5%'
                            }}
                        />
                    </Formsy.Form>
                </Dialog>
            </div>

        );
    }
}

export default AddEventComponent;



// WEBPACK FOOTER //
// ./src/components/addEventDialog.component.js